import './styles/SocialMedia.scss';
import { Browser } from '@capacitor/browser';
import { System_DeviceOrientationMap, SocialMedia_PageModeMap } from '../assets/keyMap';
import { AppContext } from '../Context';
import { useState, useContext, useEffect, useRef } from 'react';
import { DebugLogger as dlog } from '../components/Logger';
//import { ApifyClient } from "apify-client";

//mui icons
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

//graphics
import FacebookTimeline from '../assets/images/general/ppkm-facebook-timeline.png';
import InstagramTimeline from '../assets/images/general/ppkm-instagram-timeline.png';

const nonstate = {
    'facebook-link': 'https://www.facebook.com/malaysiappk/?locale=ms_MY',
    'instagram-link': 'https://www.instagram.com/malaysiappk/',
    //SCREEN_WAIT_TASKID: 'WAITSCREEN_SOCIALMEDIA'
}

interface Props {

}

const SocialMedia: React.FC<Props> = ({ }) => {
    //context
    const appContext = useContext(AppContext);
    //states
    const [pageMode, SetPageMode] = useState(SocialMedia_PageModeMap.FACEBOOK);
    //refs
    const fbSDKLoadingRef = useRef<boolean>(false);
    const lightWidgetLoadingRef = useRef<boolean>(false);
    const pageRef = useRef<any>(null);
    const fbPageRef = useRef<any>(null);

    //watchers
    useEffect(() => {
        if(pageMode == SocialMedia_PageModeMap.FACEBOOK)
            LoadFacebookSDK();
        else if(pageMode == SocialMedia_PageModeMap.INSTAGRAM)
            LoadLightWidget();
    }, [pageMode]);

    //render functions
    const RenderPage = () => {
        switch(pageMode) {
            default:
            case SocialMedia_PageModeMap.FACEBOOK:
                return RenderFacebookPage()
            case SocialMedia_PageModeMap.INSTAGRAM:
                return RenderInstagramPage()
        }
    }
    const RenderFacebookPage = () => {
        const pageWidth = (pageRef.current ? pageRef.current.clientWidth : 500);
        const scale = appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? (pageWidth / 500) * .7 : 1;

        return (
            <div className='scaler' style={{ transform: `scale(${scale},${scale})` }}>
                <div ref={fbPageRef} className="fb-page"
                    data-tabs="timeline"
                    data-href="https://www.facebook.com/malaysiappk/?locale=ms_MY"
                    data-hide-cover="false"
                    data-width={500}
                >
                </div>
            </div>
        )
    }
    const RenderInstagramPage = () => {
        return(
            <iframe src="//lightwidget.com/widgets/0df707ac48c354ca8cf9ae24b24bdfe7.html" allowTransparency={true}>
            </iframe>
        )
    }

    //exe functions
    const LoadFacebookSDK = () => {
        appContext.SetWaitScreenMessage('loading please wait');
        appContext.SetWaitScreenShouldShow(true);

        const lookoutTimeout = setTimeout(() => {
            if(fbPageRef.current && fbPageRef.current.children && fbPageRef.current.children.length > 0) {
                clearTimeout(lookoutTimeout);
                appContext.SetWaitScreenShouldShow(false);
            }
        }, 1000);

        requestAnimationFrame(() => {
            if (!fbSDKLoadingRef.current) {
                dlog('loadingFbSDK ...');
                fbSDKLoadingRef.current = true;

                if (!(window as any).FB) {
                    let script = document.getElementById("script-facebook-sdk") as HTMLScriptElement;

                    if(!script) {
                        script = document.createElement("script") as HTMLScriptElement;
                        script.id = 'script-facebook-sdk';
                        script.src = "https://connect.facebook.net/en_US/sdk.js";
                        script.async = true;
                        script.defer = true;
                        script.crossOrigin = "anonymous";

                        script.onload = () => {
                            (window as any).FB.init({
                                xfbml: true,
                                version: "v23.0",
                            });

                            (window as any).FB.XFBML.parse();

                            fbSDKLoadingRef.current = false;
                        };
                        document.body.appendChild(script);
                    } else {
                        (window as any).FB.XFBML.parse();
                    }
                } else {
                    // SDK already loaded
                    (window as any).FB.XFBML.parse();
                    fbSDKLoadingRef.current = false;
                }
            }
        });
    }
    const LoadLightWidget = () => {
        requestAnimationFrame(() => {
            if (!lightWidgetLoadingRef.current) {
                dlog('loadingLightWidgetScript ...');
                lightWidgetLoadingRef.current = true;

                let script = document.getElementById('script-light-widget') as HTMLScriptElement;

                if(!script) {
                    script = document.createElement("script");
                    script.id = 'script-light-widget';
                    script.src = "https://cdn.lightwidget.com/widgets/lightwidget.js";
                    script.async = true;
                    script.defer = true;
                    script.crossOrigin = "anonymous";
                    document.body.appendChild(script);
                }
            }
        });
    }

    return (
        <div className={'SocialMedia ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            <div className='option-panel'>
                <button className={'option-btn fb ' + (pageMode == SocialMedia_PageModeMap.FACEBOOK ? 'selected' : '')} onClick={() => SetPageMode(SocialMedia_PageModeMap.FACEBOOK)}>
                    <FacebookIcon />
                    Facebook
                </button>
                <button className={'option-btn ig ' + (pageMode == SocialMedia_PageModeMap.INSTAGRAM ? 'selected' : '')} onClick={() => SetPageMode(SocialMedia_PageModeMap.INSTAGRAM)}>
                    <InstagramIcon />
                    Instagram
                </button>
            </div>
            <div className='page' ref={pageRef}>
                {
                    RenderPage()
                }
            </div>

            {/*<div className='social-media-nav facebook' onClick={async () => { await Browser.open({ url: nonstate['facebook-link'] }) }}>
                <div className='social-media-nav-row'>
                    <FacebookIcon />
                    <span className='social-media-nav-lbl'>FACEBOOK</span>
                </div>
                {
                    RenderFBPagePluginWidget()
                }
            </div>
            <div className='social-media-nav instagram' onClick={async () => { await Browser.open({ url: nonstate['instagram-link'] }) }}>
                <div className='social-media-nav-row'>
                    <InstagramIcon />
                    <span className='social-media-nav-lbl'>INSTAGRAM</span>
                </div>
                {
                    RenderIGLightWidget()
                }
            </div>*/}
        </div>
    )
}
export default SocialMedia;